module.exports = __webpack_public_path__ + "media/application/images/ui/icon-yes-tick-999b14b44a7b4e6a73b99ba30ad91768.svg";